export default __webpack_public_path__ + "static/media/soupe-img.66045dc6.png";